import React from 'react';
import PropTypes from 'prop-types';

import {browserHistory, withRouter} from 'react-router';
import {connect} from 'react-redux';

import {prefixByChannel} from '../../routes/prefixes';

import {setActiveChannel} from '../../ducks/channels';

import Dropdown from '../../components/dropdown/Dropdown';
import ChannelLink from './ChannelLink';

@withRouter
@connect(({channels}) => ({...channels}))
export default class ChannelDropdown extends React.PureComponent {
  navigateToResource = (channel) => {
    const {activeChannel, alternateResources, location} = this.props;

    if (alternateResources && alternateResources[channel]) {
      browserHistory.push(ChannelLink.formatLink(channel, alternateResources[channel].path));
      return;
    }

    let currentRouteWithoutPrefix = '/';
    if (!alternateResources && location.pathname) {
      const isPrefixed = prefixByChannel[activeChannel];

      if (isPrefixed) {
        const [, ...routeParts] = location.pathname.split('/').filter(it => !!it);

        if (routeParts.length) {
          currentRouteWithoutPrefix = `/${routeParts.join('/')}${location.search}`;
        }
      } else {
        currentRouteWithoutPrefix = `${location.pathname}${location.search}`;
      }
    }

    browserHistory.push(ChannelLink.formatLink(channel, currentRouteWithoutPrefix));
  };

  onChannelClick = (channel) => {
    const {dispatch, onChannelSelected} = this.props;

    dispatch(setActiveChannel(channel));
    this.navigateToResource(channel);
    onChannelSelected && onChannelSelected(channel);
  };

  render() {
    const {activeChannel, availableChannels} = this.props;

    return (
      <Dropdown>
        {Object.keys(availableChannels).map((channel => (
          <Dropdown.Item
            key={channel}
            active={channel === activeChannel}
            onClick={evt => {
              evt.preventDefault();
              this.onChannelClick(channel);
            }}
          >
            {availableChannels[channel].regionName.toUpperCase()}
          </Dropdown.Item>
        )))}
      </Dropdown>
    );
  }
}



// WEBPACK FOOTER //
// ./containers/channelUtils/ChannelDropdown.js